export default "__VITE_ASSET__CBdAm7ix__"